import { runnerApi } from '../../../axios'
import { apiErrorHandler } from '../../../utils/api-error-handler'
import type {
  StartRunnerTimesnapParams,
  UpdateRunnerParams,
} from '../model/params'

export const startRunnerTimesnap = async ({
  rundownId,
  runnerId,
  params,
}: StartRunnerTimesnapParams) => {
  return await apiErrorHandler(
    runnerApi.post(`/${rundownId}/${runnerId}/timesnap/start`, null, {
      params,
    }),
  )
}

export const updateRunner = async ({
  rundownId,
  runnerId,
  payload,
}: UpdateRunnerParams) => {
  return await apiErrorHandler(
    runnerApi.put(`/${rundownId}/${runnerId}`, payload),
  )
}
